module.exports = __webpack_public_path__ + "static/media/beauty_100k.27a733bf.avif";